import { render } from "./NotificationBadge.vue?vue&type=template&id=0c98aba4&scoped=true"
import script from "./NotificationBadge.vue?vue&type=script&lang=js"
export * from "./NotificationBadge.vue?vue&type=script&lang=js"

import "./NotificationBadge.vue?vue&type=style&index=0&id=0c98aba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c98aba4"]])

export default __exports__